import { render, staticRenderFns } from "./fee-details.vue?vue&type=template&id=629ef07f&scoped=true"
import script from "./fee-details.ts?vue&type=script&lang=ts&external"
export * from "./fee-details.ts?vue&type=script&lang=ts&external"
import style0 from "./fee-details.scss?vue&type=style&index=0&id=629ef07f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ef07f",
  null
  
)

export default component.exports